<div class="rm-pm-container" [style.opacity]="!isLoading ? '1' : '0.3'">
    <div class="loader" *ngIf="isLoading">
        <div>{{message}}</div>
    </div>
    <div class="header">
        <h4>Material Group </h4>
        <span class="sub ellipses d-flex">- Cost contribution &nbsp;
            <div [popover]="popTemplateRmPm" triggers="mouseenter:mouseleave" container="body" placement="bottom"><img
                    src="../../../assets/images/icn-info.svg" alt=""></div>
        </span>&nbsp;


        <div class="full-screen" [hidden]="isLoading" (click)='popupGraph("rm")' 
            (keydown.enter)="popupGraph('rm')" (keydown.space)="popupGraph('rm')"></div>
    </div>
    <div class="rm-pm-split" [class.hide-graph]="isLoading">
        <div #graphDiv class="donut" id="graphDiv"></div>
        <div class="rm-container" (click)='popupGraph("rm")' 
            (keydown.enter)="popupGraph('rm')" (keydown.space)="popupGraph('rm')">
            <div class="value">{{rmValue}}%</div>
            <div class="legend">
                <div class="circle rm"></div>
                <div class="text">RM</div>
            </div>
        </div>
        <div class="pm-container" (click)='popupGraph("pm")' 
            (keydown.enter)="popupGraph('pm')" (keydown.space)="popupGraph('pm')">
            <div class="value">{{pmValue}}%</div>
            <div class="legend">
                <div class="circle pm"></div>
                <div class="text">PM</div>
            </div>
        </div>
    </div>
</div>
<ng-template #popTemplateRmPm>
    <div class="mb-15-rm-pm">
        <ul>
            <li>
                Cost Contribution split of RM and PM at the {{levelType}} level
                for the
                selected time
                period
            </li>
            <li>
                Click on RM/PM to view corresponding Material Group contribution at the {{levelType}} level
            </li>
        </ul>
    </div>

    <div class="tooltip-formula-rm-pm">
        <div class="tooltip-left-rm-pm">
            Cost Contribution =
        </div>
        <div class="tooltip-center-rm-pm">
            <div class="tooltip-center-top-rm-pm">
                total waste cost generated by RM/PM in the selected period

            </div>
            <hr class="tooltip-center-middle-rm-pm">
            <div class="tooltip-center-bottom-rm-pm">
                total waste cost of the {{levelType}} for the period
            </div>

        </div>
        <div class="tooltip-right-rm-pm">
            * 100
        </div>
    </div>

</ng-template>